import React from "react";
import { Link } from "react-router-dom";
import styles from "./practiceArea.module.css";
import data from "../../data/practiceAreaData.json";

import {
  FaGavel,
  FaHome,
  FaBuilding,
  FaUsers,
  FaGlobe,
  FaBalanceScale,
  FaBriefcase,
  FaPassport,
  FaArrowRight,
} from "react-icons/fa";

// Icon mapping
const iconMap = {
  FaGavel: <FaGavel />,
  FaHome: <FaHome />,
  FaBuilding: <FaBuilding />,
  FaUsers: <FaUsers />,
  FaGlobe: <FaGlobe />,
  FaBalanceScale: <FaBalanceScale />,
  FaBriefcase: <FaBriefcase />,
  FaPassport: <FaPassport />,
};

function PracticeAreas() {
  return (
    <section className={styles.practiceAreas}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Our Practice Areas</h2>

        <p className={styles.subHeading}>
          We provide comprehensive legal services tailored to protect your
          interests and guide you through every stage of the legal process.
        </p>

        <div className={styles.grid}>
          {data.map((area) => (
            <div className={styles.card} key={area.slug}>
              <div className={styles.icon}>{iconMap[area.icon]}</div>

              <h3 className={styles.title}>{area.title}</h3>

              <p className={styles.description}>{area.description}</p>

              <Link to={`/practice/${area.slug}`} className={styles.readMore}>
                Read More
                <FaArrowRight />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PracticeAreas;
